
<template>
  <Loader v-if="loader" />

  <div class="card" v-if="!autoSearch">
      <div class="formgrid grid">
          <div class="field col-12 md:col-3">
              <label>Anno</label>
              <Calendar v-model="dates" :showIcon="true" view="year" dateFormat="yy" selectionMode="multiple" :class="['inputfield w-full',{'p-invalid': validationErrors.date && submitted}]" />
              <div v-show="validationErrors.date && submitted" class="p-error">Seleziona data.</div>
          </div>
          <div class="field col-12 md:col-3">
              <label>Agente</label>
              <Dropdown @change="onChangeAgent" v-model="selectedAgent" :options="agents" optionLabel="name" optionValue="id" dataKey="id" :filter="true" placeholder="Seleziona Agente" class="w-full"/>              
          </div>
          <div class="col-12 md:col-2">
            <label>Vedi come</label> 
            <div class="flex  justify-content-start">
              <div class="flex align-items-center">
                <RadioButton id="view_admin" v-model="typeView" value="admin" />
                <label for="view_admin" class="m-2">Admin</label>
            </div>
            <div class="flex align-items-center">
                <RadioButton id="view_agent" v-model="typeView" value="agent" />
                <label  for="view_agent" class="m-2">Agente</label>
            </div>
            </div>
          </div>
          <div class="col-12 md:col-2">
            <label>Raggruppa per</label> 
            <div class="flex  justify-content-start">
              <div class="flex align-items-center">
                <RadioButton  id="group_admin" v-model="typeGroup"  value="month" />
                <label for="group_admin" class="m-2">Mese</label>
            </div>
            <div class="flex align-items-center" v-if="selectedAgent == -1">
                <RadioButton id="group_agent" v-model="typeGroup" value="agent" :disabled="selectedAgent != -1" />
                <label for="group_agent" class="m-2">Agente</label>
            </div>
            </div>
          </div>
          <div class="field col-12 md:col-2 flex align-items-end justify-content-center">
              <Button label="Cerca" icon="pi pi-search" iconPos="left" class="w-full" @click="searchData" />
          </div>
      </div>
  </div>

  

  <div v-if="hasSearched">
    <div class="card riepilogo-provvigioni" v-for="(item, year) in items" :key="year">

      <h2 v-if="!autoSearch">
        <span v-if="year.includes('-')">
          {{getMonthFormat(year)}} 
        </span>
        <span v-else>
          {{year}} 
        </span>
        <div class="text-400 text-xs">{{agents.find(item => item.id == selectedAgent)?.name || 'Agente non trovato'}}</div>
      </h2>

      <div v-else class="simplified-header">
        <div class="simplified-title">Margini</div>
        <div class="simplified-subtitle">{{year}}</div>
        <div class="simplified-entity">{{agents.find(item => item.id == selectedAgent)?.name || 'Agente non trovato'}}</div>
      </div>
   
    <DataTable ref="dt" :value="item" :filters="filters" responsiveLayout="scroll" v-if="!autoSearch">
        <!-- <template #header>
          <div class="flex justify-content-between flex-wrap">
              <div class="flex align-items-center justify-content-center mb-2">
              </div>
              <div class="flex align-items-center justify-content-center">
                  <p @click="exportCSV($event)" class="cursor-pointer text-primary" >Esporta <i class="pi pi-download"></i></p>
              </div>
          </div>
        </template> -->
        
        <template #empty>
            <div class="text-center">Nessun dato trovato.</div>
        </template>
        <ColumnGroup type="header">
          <Row>
              <Column header="" :colspan="1" style="min-width:140px;" />
              <Column class="th-power" header="POWER" :colspan="5" />
              <Column class="th-gas" header="GAS" :colspan="5" />
              <Column class="th-totali" header="TOTALI" :colspan="3" />
          </Row>
          <Row>
            <Column :field="typeGroupSearched == 'month' ? 'mese_fatturazione' : 'agente'" :header="typeGroupSearched == 'month' ? 'Mese Competenza' : 'Agente'"/>
            <Column field="" class="border-lt th-power" header="Totale QF+R (€)" style="min-width:130px;" />
            <Column field="totale_pcv_pod" class="border-lt th-power" header="Q.Fissa (€)"  :sortable="true"/>
            <Column field="totale_ricorsivo_pod" class="border-lt th-power" header="Ricorrente (€)"  :sortable="true" style="min-width:150px;" />
            <Column field="totale_pod" class="border-lt th-power" header="Pod"  :sortable="true"/>
            <Column field="totale_consumo_pod" class="border-lt th-power" header="Pod Consumo (mhw)"  :sortable="true" style="min-width:200px;" />
            <Column field="" class="border-lt th-gas" header="Totale QF+R (€)" style="min-width:130px;" />
            <Column field="totale_pcv_pdr" class="border-lt th-gas" header="Q.Fissa (€)"  :sortable="true"/>
            <Column field="totale_ricorsivo_pdr" class="border-lt th-gas" header="Ricorrente (€)"  :sortable="true" style="min-width:150px;" />
            <Column field="totale_pdr" class="border-lt th-gas" header="Pdr"  :sortable="true"/>
            <Column field="totale_consumo_pdr" class="border-lt th-gas" header="Pdr Consumo (smc)"  :sortable="true" style="min-width:200px;" />
            <Column class="border-lt th-totali" header="Margine pagato"/>
            <Column class="border-lt th-totali" header="Margine atteso"/>
            <Column class="border-lt th-totali" header="" :colspan="1"/>
          </Row>
        </ColumnGroup>
        <Column  field="" class="sticky-cell">
          <template #body="{data}">
            <span v-if="typeGroupSearched == 'month'">
              {{getMonthFormat(data.mese_fatturazione)}} 
            </span>
            <span v-else>
              {{(data.agente).toUpperCase()}} 
            </span>    
          </template>
        </Column>

        <Column field=""  class="border-lt text-right">
          <template #body="{data}">
            {{formatCurrency(data.totale_pcv_pod + data.totale_ricorsivo_pod)}} 
          </template>
        </Column>
        <Column field="totale_pcv_pod"  class="border-lt text-right">
          <template #body="{data}">
            {{formatCurrency(data.totale_pcv_pod)}} 
          </template>
        </Column>
        <Column field="totale_ricorsivo_pod"  class="border-lt text-right">
          <template #body="{data}">
            {{formatCurrency(data.totale_ricorsivo_pod)}} 
          </template>
        </Column>
        <Column field="totale_pod" class="border-lt text-right" >
          <template #body="{data}">
            {{data.totale_pod}}    
          </template>
        </Column>
        <Column field="totale_consumo_pod"  class="border-lt text-right">
          <template #body="{data}">
            {{data.totale_consumo_pod == 0 ? '0,00' : ((data.totale_consumo_pod / 1000).toFixed(2)).replace('.',',')}} 
          </template>
        </Column>

        <Column field=""  class="border-lt text-right">
          <template #body="{data}">
            {{formatCurrency(data.totale_pcv_pdr + data.totale_ricorsivo_pdr)}} 
          </template>
        </Column>
        <Column field="totale_pcv_pdr"  class="border-lt text-right">
          <template #body="{data}">
            {{formatCurrency(data.totale_pcv_pdr)}} 
          </template>
        </Column>
        <Column field="totale_ricorsivo_pdr"  class="border-lt text-right">
          <template #body="{data}">
            {{formatCurrency(data.totale_ricorsivo_pdr)}} 
          </template>
        </Column>
        <Column field="totale_pdr" class="border-lt text-right" >
          <template #body="{data}">
            {{data.totale_pdr}}   
          </template>
        </Column>
        <Column field="totale_consumo_pdr"  class="border-lt text-right">
          <template #body="{data}">
            {{(data.totale_consumo_pdr.toFixed(2)).replace('.',',')}} 
          </template>
        </Column>

        <Column class="border-lt text-right" >
          <template #body="{data}">
            {{formatCurrency(data.totale_pcv_pod + data.totale_pcv_pdr + data.totale_ricorsivo_pod + data.totale_ricorsivo_pdr)}}     
          </template>
        </Column>
        <Column class="border-lt text-right" >
          <template #body="{data}">
            {{formatCurrency(data.totale_pcv_pod_fatturato + data.totale_pcv_pdr_fatturato + data.totale_ricorsivo_pod_fatturato + data.totale_ricorsivo_pdr_fatturato)}}     
          </template>
        </Column>
        <Column>
          <template #body="{data}">
            <Button icon="pi pi-download" class="p-button-text p-button-success" @click="downloadCsv(data)" v-tooltip="`Scarica file`"/>
          </template>
        </Column>

        <ColumnGroup type="footer">
          <Row>
            <Column :colspan="1" class="td-footer" footer="Totali"/>
            <Column :colspan="10" class="td-footer" />
            <Column :colspan="1" class="td-footer" :footer="totale_euro(year)" />
            <Column :colspan="1" class="td-footer" :footer="totale_fatturato_euro(year)" />
            <Column :colspan="1" class="td-footer text-right">
              <template #footer>
                <Button
                  type="button"
                  icon="pi pi-download"
                  label="Esporta anno"
                  class="p-button-sm p-button-outlined"
                  :loading="exportYearLoading === year"
                  @click="openExportYearDialog(year)"
                  v-tooltip.top="'Scarica CSV provvigioni per l\'intero anno'"
                />
              </template>
            </Column>
          </Row>
        </ColumnGroup> 
        
    </DataTable>

    <div class="simplified-table-container" v-else>
        <table class="simplified-table-custom">
            <thead>
                <tr>
                    <th class="col-mese">Mese Competenza</th>
                    <th class="col-margine text-right">Margine pagato</th>
                    <th class="col-margine text-right">Margine atteso</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="data in item" :key="data.mese_fatturazione">
                    <td class="col-mese">{{getMonthFormat(data.mese_fatturazione)}}</td>
                    <td class="col-margine text-right">{{formatCurrency(data.totale_pcv_pod + data.totale_pcv_pdr + data.totale_ricorsivo_pod + data.totale_ricorsivo_pdr)}}</td>
                    <td class="col-margine text-right">{{formatCurrency(data.totale_pcv_pod_fatturato + data.totale_pcv_pdr_fatturato + data.totale_ricorsivo_pod_fatturato + data.totale_ricorsivo_pdr_fatturato)}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="col-mese">Totali</td>
                    <td class="col-margine text-right">{{totale_euro(year)}}</td>
                    <td class="col-margine text-right">
                      <div class="flex align-items-center justify-content-end gap-2 flex-wrap">
                        <span>{{totale_fatturato_euro(year)}}</span>
                        <Button
                          type="button"
                          icon="pi pi-download"
                          label="Esporta anno"
                          class="p-button-sm p-button-outlined"
                          :loading="exportYearLoading === year"
                          @click="openExportYearDialog(year)"
                          v-tooltip.top="'Scarica CSV provvigioni per l\'intero anno'"
                        />
                      </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
  </div>
  </div>
  

  <div class="card riepilogo-provvigioni" v-if="hasSearched && Object.keys(items).length === 0 && !loader">
    <h2>Riepilogo Provvigioni</h2>
    
    <DataTable ref="dt" :value="[]" :filters="filters" responsiveLayout="scroll" v-if="!autoSearch">
        <template #empty>
            <div class="text-center">Nessun dato trovato per l'agente e l'anno selezionati.</div>
        </template>
        <ColumnGroup type="header">
          <Row>
              <Column header="" :colspan="1" style="min-width:140px;" />
              <Column class="th-power" header="POWER" :colspan="5" />
              <Column class="th-gas" header="GAS" :colspan="5" />
              <Column class="th-totali" header="TOTALI" :colspan="3" />
          </Row>
          <Row>
            <Column header="Mese Competenza"/>
            <Column field="" class="border-lt th-power" header="Totale QF+R (€)" style="min-width:130px;" />
            <Column field="totale_pcv_pod" class="border-lt th-power" header="Q.Fissa (€)"  :sortable="true"/>
            <Column field="totale_ricorsivo_pod" class="border-lt th-power" header="Ricorrente (€)"  :sortable="true" style="min-width:150px;" />
            <Column field="totale_pod" class="border-lt th-power" header="Pod"  :sortable="true"/>
            <Column field="totale_consumo_pod" class="border-lt th-power" header="Pod Consumo (mhw)"  :sortable="true" style="min-width:200px;" />
            <Column field="" class="border-lt th-gas" header="Totale QF+R (€)" style="min-width:130px;" />
            <Column field="totale_pcv_pdr" class="border-lt th-gas" header="Q.Fissa (€)"  :sortable="true"/>
            <Column field="totale_ricorsivo_pdr" class="border-lt th-gas" header="Ricorrente (€)"  :sortable="true" style="min-width:150px;" />
            <Column field="totale_pdr" class="border-lt th-gas" header="Pdr"  :sortable="true"/>
            <Column field="totale_consumo_pdr" class="border-lt th-gas" header="Pdr Consumo (smc)"  :sortable="true" style="min-width:200px;" />
            <Column class="border-lt th-totali" header="Margine pagato"/>
            <Column class="border-lt th-totali" header="Margine atteso"/>
            <Column class="border-lt th-totali" header="" :colspan="1"/>
          </Row>
        </ColumnGroup>
    </DataTable>

   
    <div class="simplified-table-container" v-else>
        <table class="simplified-table-custom">
            <thead>
                <tr>
                    <th class="col-mese">Mese Competenza</th>
                    <th class="col-margine text-right">Margine pagato</th>
                    <th class="col-margine text-right">Margine atteso</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td colspan="3" class="text-center">Nessun dato trovato per l'agente e l'anno selezionati.</td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
  
  <Dialog
    v-model:visible="exportYearDialogVisible"
    modal
    :closable="!exportYearRequestLoading"
    :dismissableMask="!exportYearRequestLoading"
    header="Seleziona tipo export anno"
    :style="{ width: '28rem' }"
  >
    <div class="mb-3">
      Scegli la tipologia di export annuale da scaricare.
    </div>
    <div class="flex justify-content-end gap-2">
      <Button
        type="button"
        label="Totale"
        class="p-button-outlined"
        :disabled="exportYearRequestLoading"
        @click="confirmExportProvvigioniAnno(false)"
      />
      <Button
        type="button"
        label="Puntuale"
        class="ml-4 p-button-outlined"
        :loading="exportYearRequestLoading"
        @click="confirmExportProvvigioniAnno(true)"
      />
    </div>
  </Dialog>


</template>

<script>
import moment from 'moment'
import Service from '@/services/ask-pratiche/pratiche-service'
import UtilityService from '@/services/ask-management/utility-service'
import { ref, onMounted, getCurrentInstance, watch } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
    props: {
      idAgente: {
        type: Number,
        default: null
      },
      annoSelezionato: {
        type: Number,
        default: null
      },
      autoSearch: {
        type: Boolean,
        default: false
      }
    },
    setup(props) {

      const dt = ref();
      const loader = ref(false)
      const filters = ref({
          'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      });
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const formatDate = self.appContext.config.globalProperties.$formatDate
      const service = new Service(self.$http, self.$eventBus)
      const utilityService = new UtilityService(self.$http, self.$eventBus)
      const items = ref([]);
      const originalItems = ref([]);
      const agents = ref()
      const selectedAgent = ref(-1)
      const typeView = ref('admin');
      const typeGroup = ref('month');
      const typeGroupSearched = ref('');
      const dates = ref([]/*moment(new Date()).format('YYYY')*/);
      const validationErrors = ref({})
      const submitted = ref(false)
      const hasSearched = ref(false) 


      

      onMounted(() =>{
        
        getAgenti()
        
        if (props.autoSearch && props.idAgente && props.annoSelezionato) {
        
          selectedAgent.value = props.idAgente
          dates.value = [new Date(props.annoSelezionato, 0, 1)] 
          typeGroup.value = 'month' 
          typeView.value = 'admin' 
          hasSearched.value = false 
          
          setTimeout(() => {
            
            searchData()
          }, 500) 
        }
      })

      watch(() => [props.idAgente, props.annoSelezionato], ([newIdAgente, newAnnoSelezionato], [oldIdAgente, oldAnnoSelezionato]) => {
       
        if (props.autoSearch && newIdAgente && newAnnoSelezionato && 
            (newIdAgente !== oldIdAgente || newAnnoSelezionato !== oldAnnoSelezionato)) {
         
          selectedAgent.value = newIdAgente
          dates.value = [new Date(newAnnoSelezionato, 0, 1)]
          typeGroup.value = 'month'
          typeView.value = 'admin'
          hasSearched.value = false 
          
     
          setTimeout(() => {
           
            searchData()
          }, 100)
        }
      }, { immediate: false })

      const getAgenti = () => {
        loader.value = true
        utilityService.getAgenti(1)
        .then((res) =>{
          res.items.unshift({
            id: -1,
            name: 'Tutti'
          })
          agents.value = res.items
        })
        .finally(()=>{
          loader.value = false
        })
      }

      const searchData = async () => {
        submitted.value = true;
        if (validateData()) {
          let dates_selected = dates.value.map(date => moment(date).year());
         
          loader.value = true
          service.getSummaryProvvigioni(selectedAgent.value, dates_selected, typeView.value, typeGroup.value)
          .then((res) => {
            
            items.value = res.items
            originalItems.value = res.items
            typeGroupSearched.value = typeGroup.value
            hasSearched.value = true 
          }).finally(() => {
            loader.value = false
          })
        }
      }


      const totale_euro = (year) => {
        let total = 0;
        for(let el of items.value[year]) {
            total += el.totale_pcv_pod + el.totale_ricorsivo_pod + el.totale_pcv_pdr + el.totale_ricorsivo_pdr;
        }
        return formatCurrency(total);
      };
      const totale_fatturato_euro = (year) => {
        let total = 0;
        for(let el of items.value[year]) {
            total += el.totale_pcv_pod_fatturato + el.totale_ricorsivo_pod_fatturato + el.totale_pcv_pdr_fatturato + el.totale_ricorsivo_pdr_fatturato;
        }
        return formatCurrency(total);
      };

      const onChangeAgent = () => {
        if (selectedAgent.value != -1) {
          typeGroup.value = 'month'
        }
      }
    
      
      const formatCurrency = (value) => {
        return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
      };

      
      const getMonthFormat = (date) => {
        return moment(new Date(date)).locale('it').format('MMMM YYYY').toUpperCase()
      }

      const exportCSV = () => {
        dt.value.exportCSV();
      };

      const validateData = () =>{
          if (dates.value == null)
            validationErrors.value['date'] = true;
          else 
            delete validationErrors.value['date'];
    
        return !Object.keys(validationErrors.value).length;
      }

      const downloadCsv = (data) => {
        let agente_id = getAgenteIdforExport(data)
        loader.value = true
        service.downloadCsvProvvigioni(agente_id, data.mese_fatturazione)
        .finally(() => {
          loader.value = false
        })
      }

      const exportYearLoading = ref(null)
      const exportYearDialogVisible = ref(false)
      const exportYearDialogYearKey = ref(null)
      const exportYearRequestLoading = ref(false)

      const getCalendarYearFromCardKey = (yearKey) => {
        const y = parseInt(String(yearKey).slice(0, 4), 10)
        return Number.isFinite(y) ? y : moment().year()
      }

      const openExportYearDialog = (yearKey) => {
        exportYearDialogYearKey.value = yearKey
        exportYearDialogVisible.value = true
      }

      const confirmExportProvvigioniAnno = (detail) => {
        if (!exportYearDialogYearKey.value) {
          exportYearDialogVisible.value = false
          return
        }

        const yearKey = exportYearDialogYearKey.value
        const calendarYear = getCalendarYearFromCardKey(yearKey)
        const agentId = selectedAgent.value > 0 ? selectedAgent.value : null
        exportYearDialogVisible.value = false
        exportYearRequestLoading.value = true
        exportYearLoading.value = yearKey
        loader.value = true
        service.exportSummaryProvvigioniByYear(agentId, calendarYear, detail)
          .finally(() => {
            exportYearLoading.value = null
            exportYearRequestLoading.value = false
            exportYearDialogYearKey.value = null
            loader.value = false
          })
      }

      const getAgenteIdforExport = (data) => {
        let id = null
        if (selectedAgent.value > 0) {
          id = selectedAgent.value
        }else{
          id = typeGroup.value == 'agent' ? data.id_agente_assegnatario : null
        }
        return id
      }


      return { 
        dt,
        moment,
        items,
        loader, 
        filters, 
        dates,
        searchData,
        typeView,
        typeGroup,
        typeGroupSearched,
        agents,
        selectedAgent,
        onChangeAgent,
        exportCSV,
        validationErrors,
        submitted,
        formatDate,
        formatCurrency,
        getMonthFormat,
        totale_euro,
        totale_fatturato_euro,
        downloadCsv,
        hasSearched,
        exportYearLoading,
        openExportYearDialog,
        exportYearDialogVisible,
        exportYearRequestLoading,
        confirmExportProvvigioniAnno
      }
  }
}
</script>



<style>


.riepilogo-provvigioni .p-datatable .p-datatable-thead > tr > th.th-power {
  background: rgba(251, 230, 138, 0.742) !important;
  min-width: 120px;
}

.riepilogo-provvigioni .p-datatable .p-datatable-thead > tr > th.th-gas {
  background: rgba(137, 185, 244, 0.412) !important;  
  min-width: 120px;
}

.riepilogo-provvigioni .p-datatable .p-datatable-tbody > tr > td.border-lt, .p-datatable .p-datatable-thead > tr > th.border-lt {
  border-left: 1px solid rgba(62, 62, 62, 0.093);
   
}
.riepilogo-provvigioni .p-datatable .p-datatable-tfoot > tr > td.td-footer {
 color: #0a8cf5 !important;
 font-size: 15px;
}
.riepilogo-provvigioni .p-datatable .p-datatable-tbody > tr > td.sticky-cell {
  position: sticky !important;
  left: 0 !important;
  background-color: rgb(249, 249, 249);
}

.riepilogo-provvigioni .p-datatable.simplified-table {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-thead > tr > th {
  background-color: #f8f9fa !important;
  border-bottom: 1px solid #e5e7eb;
  padding: 1rem;
  font-weight: 600;
  color: #374151;
  text-align: left;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-thead > tr > th.text-right {
  text-align: right;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-tbody > tr > td {
  padding: 1rem;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-tbody > tr > td.text-right {
  text-align: right;
  font-weight: 500;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-tfoot > tr > td {
  background-color: #f8f9fa !important;
  border-top: 2px solid #e5e7eb;
  padding: 1rem;
  font-weight: 600;
  color: #0a8cf5;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-tfoot > tr > td.text-right {
  text-align: right;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-tbody > tr:hover {
  background-color: #f9fafb;
}

.riepilogo-provvigioni .p-datatable.simplified-table table {
  width: 100% !important;
  table-layout: fixed !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table table th:nth-child(1),
.riepilogo-provvigioni .p-datatable.simplified-table table td:nth-child(1) {
  width: 40% !important;
  text-align: left !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table table th:nth-child(2),
.riepilogo-provvigioni .p-datatable.simplified-table table td:nth-child(2) {
  width: 30% !important;
  text-align: right !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table table th:nth-child(3),
.riepilogo-provvigioni .p-datatable.simplified-table table td:nth-child(3) {
  width: 30% !important;
  text-align: right !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table table tfoot td:nth-child(1) {
  width: 40% !important;
  text-align: left !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table table tfoot td:nth-child(2),
.riepilogo-provvigioni .p-datatable.simplified-table table tfoot td:nth-child(3) {
  width: 30% !important;
  text-align: right !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-thead > tr > th,
.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-tbody > tr > td,
.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-tfoot > tr > td {
  box-sizing: border-box !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-wrapper {
  display: grid !important;
  grid-template-columns: 40% 30% 30% !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-thead > tr,
.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-tbody > tr,
.riepilogo-provvigioni .p-datatable.simplified-table .p-datatable-tfoot > tr {
  display: grid !important;
  grid-template-columns: 40% 30% 30% !important;
  width: 100% !important;
}

.riepilogo-provvigioni .simplified-table-container {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.riepilogo-provvigioni .simplified-table-custom {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.riepilogo-provvigioni .simplified-table-custom th {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
  padding: 1rem;
  font-weight: 600;
  color: #374151;
  text-align: left;
}

.riepilogo-provvigioni .simplified-table-custom th.text-right {
  text-align: right;
}

.riepilogo-provvigioni .simplified-table-custom td {
  padding: 1rem;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}

.riepilogo-provvigioni .simplified-table-custom td.text-right {
  text-align: right;
  font-weight: 500;
}

.riepilogo-provvigioni .simplified-table-custom tfoot td {
  background-color: #f8f9fa;
  border-top: 2px solid #e5e7eb;
  font-weight: 600;
  color: #0a8cf5;
}

.riepilogo-provvigioni .simplified-table-custom tfoot td.text-right {
  text-align: right;
}

.riepilogo-provvigioni .simplified-table-custom tbody tr:hover {
  background-color: #f9fafb;
}

.riepilogo-provvigioni .simplified-table-custom .col-mese {
  width: 40%;
}

.riepilogo-provvigioni .simplified-table-custom .col-margine {
  width: 30%;
}

/* Stili specifici per le colonne */
.riepilogo-provvigioni .p-datatable.simplified-table .col-mese {
  width: 40% !important;
  min-width: 200px;
}

.riepilogo-provvigioni .p-datatable.simplified-table .col-margine {
  width: 30% !important;
  min-width: 150px;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-column-header.col-mese {
  text-align: left !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-column-header.col-margine {
  text-align: right !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-column-header-content.col-mese {
  justify-content: flex-start !important;
}

.riepilogo-provvigioni .p-datatable.simplified-table .p-column-header-content.col-margine {
  justify-content: flex-end !important;
}

.riepilogo-provvigioni .simplified-header {
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e5e7eb;
}

.riepilogo-provvigioni .simplified-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #374151;
  margin-bottom: 0.25rem;
}

.riepilogo-provvigioni .simplified-subtitle {
  font-size: 1.25rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.25rem;
}

.riepilogo-provvigioni .simplified-entity {
  font-size: 0.875rem;
  color: #9ca3af;
  margin-bottom: 0;
}

</style>
<style scoped>
.btn-year {
  min-width: 100px;
}
</style>
